import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  linkText: {
    textDecoration: 'underline',
    color: 'inherit',
  },
}));
